import { HelpRequestList } from '@/help/HelpRequestList'

export function HelpRequests() {
  return <HelpRequestList />
}
